// extracted by mini-css-extract-plugin
export default {"main_container":"Home_main_container__6+BOX","new":"Home_new__usd8y"};